import SectionListProps from '../../../../components/HomePage/components/SectionBrowser/SectionListProps';
import { SectionSlot } from '../../../../components/Toolkit/SectionSlot/SectionSlot';
import FarmingIcons from '../../../../components/HomePage/Icons/FarmingIcons';
import { getDashIcon } from '../../../../components/HomePage/Icons/DashIcons';
import SectionContainer from '../../../../components/HomePage/components/SectionBrowser/styles/SectionContainer';
import { restoreScrollPosition } from '../../../../helpers/scroll';

function FarmingSectionsList({ sections, dashLinks }: SectionListProps) {
  const updatedSections = [
    ...sections.slice(0, 2),
    {
      displayName: 'Tractors from Dealerships',
      name: 'tractorsfromdealerships',
      id: -1,
      link: 'tractors?sort=pricedesc&sellerType=pro&containsValidPrice=true&price_from=15000&price_to=280000',
    },
    ...sections.slice(2),
  ];

  return (
    <SectionContainer data-testid="farming-section-list">
      {dashLinks?.map(({ displayName, count, icon, url }, index) => {
        return (
          <li key={index}>
            <a href={url} onClick={() => restoreScrollPosition(url)}>
              <SectionSlot
                icon={getDashIcon(icon)}
                text={displayName}
                quantity={count}
              />
            </a>
          </li>
        );
      })}
      {updatedSections.map((section, index) => {
        const link = section.link ? section.link : section.name;
        return (
          <li key={index}>
            <a
              href={`/${link}`}
              onClick={() => restoreScrollPosition(`/${link}`)}
            >
              <SectionSlot
                icon={FarmingIcons[section.name]}
                text={section.displayName}
              />
            </a>
          </li>
        );
      })}
    </SectionContainer>
  );
}

export { FarmingSectionsList };
